import {Controller} from "stimulus"
import $ from 'jquery';
import toastr from 'toastr/toastr'
import bootbox from 'bootbox';
import 'toastr/toastr.scss'

import 'leaflet/dist/leaflet.css'
import 'leaflet'
import {OpenStreetMapProvider} from 'leaflet-geosearch'
import {post} from "@rails/request.js";
import {getFacilities, getRates, getRoomTypes, getStars} from "./hotel_search_controller";

import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'

const provider = new OpenStreetMapProvider();

// Variables
let latlngs = [[24.000, -73.619], [19.300, -85.590]];

function getPointData(lat, lng, latlng, addrs = null, popup = null) {
    var reversegeocode = 'https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lng + '&zoom=18&addressdetails=1';
    $.getJSON(reversegeocode, function (data) {
        var msg = `${data.display_name} <br> <span class="helper_text small">Esta dirección es autogenerada, revise el campo de dirección en el formulario para verificar que sea la correcta.</span>`;
        if (addrs !== null) {
            addrs.value = data.display_name
        }
        if (popup !== null) {
            popup
                .setLatLng(latlng)
                .setContent(msg)
                .openOn(edit_map);
        }
    });
}

export default class extends Controller {
    static targets = ["destination", "dateRange", "stars"]

    connect() {
        if (window.mapInstance) return;

        this.overlay = document.getElementById('overlay_map_load');

        // Inicializar el mapa pequeño (en el modal)
        this.initSmallMap();

        // Inicializar el mapa grande (en la página principal)
        this.initBigMap();

        // Sincronizar los mapas
        this.syncMaps();

        // Configurar botones
        this.setupMapButtons();

        // Cargar hoteles iniciales
        this.loadInitialHotels();
        this.element.hotetecMapController = this;

        // Estado inicial: mapa pequeño visible, grande oculto
        this.isExpanded = false;

        // Variable para debounce
        this.moveTimeout = null;
    }

    initSmallMap() {
        const container = document.getElementById('map-small');
        if (!container) return;

        container.innerHTML = '';

        this.smallMap = L.map('map-small', {
            zoom: 6.5,
            minZoom: 2,
            zoomSnap: 0.25,
            scrollWheelZoom: false,
            touchZoom: true,
            worldCopyJump: true
        });

        this.smallMap.fitBounds(latlngs);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; LaberintoTech',
            maxZoom: 19
        }).addTo(this.smallMap);

        L.control.scale().addTo(this.smallMap);

        this.smallMarkersLayer = L.layerGroup().addTo(this.smallMap);

        this.setupCtrlScrollZoom(this.smallMap);

        // Event listener para actualizar hoteles al mover el mapa
        this.smallMap.on('moveend', () => {
            if (!this.isExpanded) {
                this.handleMapChange(this.smallMap);
            }
        });
    }

    initBigMap() {
        const container = document.getElementById('map');
        if (!container) return;

        container.innerHTML = '';

        this.bigMap = L.map('map', {
            zoom: 6.5,
            minZoom: 2,
            zoomSnap: 0.25,
            scrollWheelZoom: false,
            touchZoom: true,
            worldCopyJump: true
        });

        this.bigMap.fitBounds(latlngs);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; LaberintoTech',
            maxZoom: 19
        }).addTo(this.bigMap);

        L.control.scale().addTo(this.bigMap);

        this.bigMarkersLayer = L.layerGroup().addTo(this.bigMap);

        this.setupCtrlScrollZoom(this.bigMap);

        // Event listener para actualizar hoteles al mover el mapa
        this.bigMap.on('moveend', () => {
            if (this.isExpanded) {
                this.handleMapChange(this.bigMap);
            }
        });

        window.mapInstance = this.bigMap;
        window.mapMarkersLayer = this.bigMarkersLayer;
    }

    syncMaps() {
        if (this.smallMap && this.bigMap) {
            this.smallMap.on('moveend', () => {
                if (!this.isExpanded) {
                    const center = this.smallMap.getCenter();
                    const zoom = this.smallMap.getZoom();
                    this.bigMap.setView(center, zoom, { animate: false });
                }
            });

            this.bigMap.on('moveend', () => {
                if (this.isExpanded) {
                    const center = this.bigMap.getCenter();
                    const zoom = this.bigMap.getZoom();
                    this.smallMap.setView(center, zoom, { animate: false });
                }
            });
        }
    }

    setupMapButtons() {
        // Botón para expandir el mapa (del modal)
        const expandBtn = document.getElementById('expand-map-btn');
        if (expandBtn) {
            const newExpandBtn = expandBtn.cloneNode(true);
            expandBtn.parentNode.replaceChild(newExpandBtn, expandBtn);

            newExpandBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.expandMap();
            });
        }

        // Botón para mostrar/ocultar mapa (flotante)
        const toggleBtn = document.getElementById('toggle-map-btn');
        if (toggleBtn) {
            const newToggleBtn = toggleBtn.cloneNode(true);
            toggleBtn.parentNode.replaceChild(newToggleBtn, toggleBtn);

            newToggleBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleMap();
            });
        }
    }

    expandMap() {
        if (this.isExpanded) return;

        const smallMapSection = document.getElementById('small-map-section');
        const bigContainer = document.getElementById('container-map');
        const toggleBtn = document.getElementById('toggle-map-btn');

        if (!smallMapSection || !bigContainer) return;

        /*console.log('Expanding map');*/

        // Guardar los bounds actuales del mapa pequeño antes de expandir
        const currentBounds = this.smallMap.getBounds();

        // Sincronizar el mapa grande con la posición del pequeño antes de mostrar
        const center = this.smallMap.getCenter();
        const zoom = this.smallMap.getZoom();
        this.bigMap.setView(center, zoom);

        // Ocultar toda la sección del mapa pequeño
        smallMapSection.style.display = 'none';

        // Mostrar contenedor grande
        bigContainer.classList.remove('d-none');

        // Forzar recálculo del mapa grande
        setTimeout(() => {
            this.bigMap.invalidateSize(true);

            // Ajustar los bounds del mapa grande basado en los marcadores actuales
            this.adjustMapBoundsToMarkers(this.bigMap);

            // Disparar handleMapChange para actualizar la lista con la vista actual
            this.handleMapChange(this.bigMap);
        }, 100);

        // Actualizar texto del botón flotante
        if (toggleBtn) {
            toggleBtn.innerHTML = '<i class="fa fa-map"></i> Ocultar mapa';
        }

        this.isExpanded = true;

        // Disparar evento para actualizar la posición sticky
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    }

    collapseMap() {
        if (!this.isExpanded) return;

        const smallMapSection = document.getElementById('small-map-section');
        const bigContainer = document.getElementById('container-map');
        const toggleBtn = document.getElementById('toggle-map-btn');

        if (!smallMapSection || !bigContainer) return;

        /*console.log('Collapsing map');*/

        // Ocultar contenedor grande
        bigContainer.classList.add('d-none');

        // Mostrar nuevamente toda la sección del mapa pequeño
        smallMapSection.style.display = '';

        // Forzar recálculo del mapa pequeño
        setTimeout(() => {
            this.smallMap.invalidateSize(true);

            // Ajustar los bounds del mapa pequeño basado en los marcadores actuales
            this.adjustMapBoundsToMarkers(this.smallMap);

            // Disparar handleMapChange para actualizar la lista con la vista actual
            this.handleMapChange(this.smallMap);
        }, 100);

        // Actualizar texto del botón flotante
        if (toggleBtn) {
            toggleBtn.innerHTML = '<i class="fa fa-map"></i> Mostrar mapa';
        }

        this.isExpanded = false;
    }

    toggleMap() {
        if (this.isExpanded) {
            this.collapseMap();
        } else {
            this.expandMap();
        }
    }

    adjustMapBoundsToMarkers(map) {
        // Obtener todos los marcadores del mapa actual
        const markersLayer = map === this.smallMap ? this.smallMarkersLayer : this.bigMarkersLayer;

        if (!markersLayer) return;

        const markers = markersLayer.getLayers();

        if (markers.length === 0) {
            // Si no hay marcadores, centrar en Cuba
            map.fitBounds(latlngs, {padding: [50, 50]});
            return;
        }

        // Recolectar todas las coordenadas de los marcadores
        const bounds = L.latLngBounds();
        markers.forEach(marker => {
            const latLng = marker.getLatLng();
            bounds.extend(latLng);
        });

        // Ajustar el mapa con padding para que todos los marcadores sean visibles
        // El padding es mayor para el mapa pequeño para asegurar que todos los puntos queden dentro
        const padding = map === this.smallMap ? [50, 50] : [30, 30];

        map.fitBounds(bounds, { padding: padding });

        /*console.log(`Adjusted map bounds for ${map === this.smallMap ? 'small' : 'big'} map. Markers count: ${markers.length}`);*/
    }

    setupCtrlScrollZoom(mapInstance) {
        const mapContainer = mapInstance.getContainer();
        if (!mapContainer) return;

        let helpMessage = null;
        let helpMessageTimeout = null;
        let zoomTimeout = null;

        const showHelpMessage = (map) => {
            if (helpMessage) return;
            const center = map.getCenter();
            helpMessage = L.popup({
                content: '🔍 Usa <strong>Ctrl + scroll</strong> para hacer zoom en el mapa',
                className: 'ctrl-scroll-hint',
                autoClose: false,
                closeButton: false,
                maxWidth: 250
            }).setLatLng(center).openOn(map);

            if (helpMessageTimeout) clearTimeout(helpMessageTimeout);
            helpMessageTimeout = setTimeout(() => {
                if (helpMessage) {
                    map.closePopup(helpMessage);
                    helpMessage = null;
                }
            }, 3000);
        };

        const hideHelpMessage = () => {
            if (helpMessage) {
                if (this.smallMap) this.smallMap.closePopup(helpMessage);
                if (this.bigMap) this.bigMap.closePopup(helpMessage);
                helpMessage = null;
            }
            if (helpMessageTimeout) {
                clearTimeout(helpMessageTimeout);
                helpMessageTimeout = null;
            }
        };

        const wheelHandler = (e) => {
            if (e.ctrlKey) {
                e.preventDefault();
                e.stopPropagation();
                hideHelpMessage();

                const delta = e.deltaY;
                const currentZoom = mapInstance.getZoom();
                const newZoom = delta < 0 ? currentZoom + 1 : currentZoom - 1;

                if (newZoom >= mapInstance.getMinZoom() && newZoom <= mapInstance.getMaxZoom()) {
                    const mousePoint = mapInstance.mouseEventToContainerPoint(e);
                    const mouseLatLng = mapInstance.containerPointToLatLng(mousePoint);
                    mapInstance.setView(mouseLatLng, newZoom);

                    if (zoomTimeout) clearTimeout(zoomTimeout);
                    zoomTimeout = setTimeout(() => {
                        this.handleMapChange(mapInstance);
                    }, 300);
                }

                return false;
            } else {
                e.preventDefault();
                e.stopPropagation();
                showHelpMessage(mapInstance);
                return false;
            }
        };

        mapContainer.addEventListener('wheel', wheelHandler, { passive: false });

        const mouseEnterHandler = () => {
            document.body.style.overflow = 'hidden';
        };

        const mouseLeaveHandler = () => {
            document.body.style.overflow = '';
            hideHelpMessage();
        };

        mapContainer.addEventListener('mouseenter', mouseEnterHandler);
        mapContainer.addEventListener('mouseleave', mouseLeaveHandler);
    }

    async handleMapChange(activeMap = null) {
        const mapToUse = activeMap || (this.isExpanded ? this.bigMap : this.smallMap);

        if (!mapToUse) return;

        const bounds = mapToUse.getBounds();

        /*console.log('Map moved, fetching hotels for bounds:', bounds);*/

        post(`/admin/hotel/reservas2_search_hotel`, {
            query: {
                north: bounds.getNorth(),
                south: bounds.getSouth(),
                east: bounds.getEast(),
                west: bounds.getWest(),
                destination: this.destinationTarget?.value,
                stars: getStars(),
                rates: getRates(),
                facilities: getFacilities(),
                room_types: getRoomTypes()
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            /*console.log("Lista de Hoteles actualizada satisfactoriamente.");*/
        }).catch(error => {
            /*console.error("Error updating hotels:", error);*/
        });
    }

    updateMarkers(hotels, hotels_rest = [], update_list = false) {
        // Actualizar marcadores en ambos mapas
        this.updateMapMarkers(this.smallMap, this.smallMarkersLayer, hotels, hotels_rest);
        this.updateMapMarkers(this.bigMap, this.bigMarkersLayer, hotels, hotels_rest);

        // Ajustar los bounds del mapa actualmente visible
        setTimeout(() => {
            if (this.isExpanded) {
                this.adjustMapBoundsToMarkers(this.bigMap);
            } else {
                this.adjustMapBoundsToMarkers(this.smallMap);
            }
        }, 100);
    }

    updateMapMarkers(map, markersLayer, hotels, hotels_rest = []) {
        if (!markersLayer || !map) return;

        markersLayer.clearLayers();

        if (!hotels || hotels.length === 0) {
            // No ajustamos bounds aquí, lo haremos en updateMarkers
            return;
        }

        const pinUrl = '/pin.png';
        const myIcon = L.icon({
            iconUrl: pinUrl,
            className: 'pin-map',
            iconSize: [44, 44],
            iconAnchor: [22, 44],
            popupAnchor: [0, -44]
        });

        const myIconRest = createPin('#273746');

        hotels.forEach(hotel => {
            const marker = L.marker(
                [parseFloat(hotel.latitude), parseFloat(hotel.longitude)],
                {icon: myIcon}
            ).bindPopup(`<h3 style="margin-bottom: 0 !important;">${hotel.name}</h3>
                        ${hotel.estrellas}
                        ${(hotel.rates) ? `<br><strong>Tarifas:</strong> ${hotel.rates}` : ''}
                        <br><strong>Dirección:</strong> ${hotel.address}
                        <br><strong>Código Postal:</strong> ${hotel.postal_code}
                        <br>
                            <div class="d-flex justify-content-between align-items-center mt-2">
                                <a data-action="click->setValue#saltarA" data-target="#card-hotel-${hotel.id}" class="btn btn-sm btn-info hotel-card-container-btn d-block d-md-none" style="width: fit-content; color: white;">
                                    <i class="fa fa-map-marker"></i> Hotel
                                </a>
                                <button class="btn btn-sm btn-warning hotel-card-container-btn" data-action="click->hotel-search#go_to_hotel_availability" data-hotel="${hotel.id}">
                                    <i class="fa fa-shopping-cart"></i> Reservar
                                </button>
                            </div>`);
            markersLayer.addLayer(marker);
        });

        let restMarkersLayer = map.restMarkersLayer;
        if (!restMarkersLayer) {
            restMarkersLayer = L.layerGroup().addTo(map);
            map.restMarkersLayer = restMarkersLayer;
        } else {
            restMarkersLayer.clearLayers();
        }

        hotels_rest.forEach(hotel => {
            const marker = L.marker(
                [parseFloat(hotel.latitude), parseFloat(hotel.longitude)],
                {icon: myIconRest}
            ).bindPopup(`<h3 style="margin-bottom: 0 !important;">${hotel.name}</h3>
                        ${hotel.estrellas}
                        ${(hotel.rates) ? `<br><strong>Tarifas:</strong> ${hotel.rates}` : ''}
                        <br><strong>Dirección:</strong> ${hotel.address}
                        <br><strong>Código Postal:</strong> ${hotel.postal_code}
                        <br><a data-action="click->setValue#saltarA" data-target="#card-hotel-${hotel.id}" class="btn btn-info hotel-card-container-btn d-block d-md-none" style="width: fit-content; margin-top: .5rem; color: white;">
                                <i class="fa fa-map-marker"></i> Hotel
                            </a>`);
            restMarkersLayer.addLayer(marker);
        });
    }

    loadInitialHotels() {
        try {
            fetch(`/${I18n.locale}/admin/hotel/hoteles_map?format=json`)
                .then(response => response.json())
                .then(data => {
                    if (data.total > 0) {
                        this.updateMarkers(data.rows);
                    }
                    if (this.overlay) {
                        this.overlay.style.display = 'none';
                    }
                })
                .catch(err => {
                    /*console.error("Error al cargar hoteles iniciales", err);*/
                    if (this.overlay) {
                        this.overlay.innerHTML = '<h1>Error al cargar datos</h1>';
                        setTimeout(() => {
                            this.overlay.style.display = 'none';
                        }, 2000);
                    }
                });
        } catch (err) {
            /*console.error("Error al cargar hoteles iniciales", err);*/
            if (this.overlay) {
                this.overlay.style.display = 'none';
            }
        }
    }

    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();
                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();
                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response?.url?.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }
}

function createPin(color = '#c0392b') {
    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 512 512">
      <path fill="${color}" d="M256 0C156.698 0 76 80.698 76 180c0 123.598 180 332 180 332s180-208.402 180-332C436 80.698 355.302 0 256 0z"/>
      <circle fill="white" cx="256" cy="180" r="80"/>
    </svg>`;
    return L.divIcon({
        html: svg,
        className: 'pin-map-svg',
        iconSize: [30, 40],
        popupAnchor: [0, -10]
    });
}